module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgBdZCNEcMgCIULLtANqwtonESdoGbDLuBZyFWPEuUuP8D3EB/knBMiHr13G0I4H4sopbzokwGgEouWi5z8GjeYe/Q8KT2wtRZHU4sGLPQO+J1SssaY96jyemOAhL33FUamRSou+BoiqxvRhDlQdsiArkfTen+1ecLiglI0LccN7Mg9N6cK92AFj51X7uEO5ogxVnVSRlIV+v9oeCUi9vwCyFZnktvQIrYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/close.png
// module id = MXp7
// module chunks = 0